<template>
   <div>
   <form @submit.prevent="EditProfile" class="h-full w-full md:h-screen flex flex-wrap justify-center">
        <div  >
            <!-- Slug input -->
            <div class="m-2">
                <Label for="slug" class="text-white" value="شناسه" />
                <Label  class="text-xs text-white" value="(اسمی منحصر به فرد که حداقل باید 7 کاراکتر انگلیسی کوچک باشد)" />
                    <Input 
                        id="slug"
                        type="text"
                        placeholder="شناسه"
                        class="block w-full border border-red-900"
                        v-model="store.slug"
                        required
                        autofocus
                        autocomplete="slug"
                        v-on:keypress="isLetter($event)"
                    />
            </div>
           <!-- <div class="flex m-1">
            <Label for="IsActive" value="فعال" class="text-white" />
            <Input
                        id="isActive"
                        type="checkbox"
                        placeholder="isActive"
                        v-model="store.isActive"
                        required
                        autofocus
                        autocomplete="isActive"
                        checked="store.isActive"
                    />
            </div>-->
            <div class="flex mt-4 text-white mr-2">
                   <label for="default" class="block text-sm ">فعال </label>
                  <input id="default" type="checkbox" v-model="store.isActive" >
            </div>
           
           <!-- <div>
                <Label for="acceptterms">
                    <div class="flex items-center">
                        <Checkbox class="mr-2" name="isActive" id="isActive" v-model:checked="store.isActive" />

                        <div class="text-white ">
                            فعال 
                        </div>
                    </div>
                </Label>
            </div>-->
            <TabGroup>
               <TabList class="flex space-x-1 rounded-xl bg-blue-900/20 p-1 px-2">
               <Tab
                  v-for="(category) in localizations"
                  as="template"
                  :key="category.id"
                  v-slot="{ selected }"
               >
                  <button
                     :text="category.localname"
                     :class="[
                     'w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-blue-700',
                     'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2',
                     selected
                        ? 'bg-white shadow'
                        : 'text-blue-100 hover:bg-white/[0.12] hover:text-white',
                     ]"
                  >
                     {{ category.name }}
                  </button>
               </Tab>
               </TabList>
               <TabPanels class="mt-2 px-2">
               <TabPanel
                  v-for="(items) in this.store.storelocalization"
                  :key="items.languageId"
                  :class="[
                     'rounded-xl bg-white p-3',
                     'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2',
                  ]"
               >
                <!-- ShopName input -->
                <div class="space-y-2 ">
                  <Label class="text-gray-700"   for="shopname" value="نام فروشگاه"/>
                     <Input 
                        id="shopname"
                        type="text"
                        placeholder="نام فروشگاه"
                        class="block w-full border border-green-900"
                        v-model="items.shopName"
                        required
                        autofocus
                        autocomplete="shopname"
                     />
                 </div>
                 <!-- SubTitle input -->
                 <div class="space-y-2">
                    <Label  class="text-gray-700 mt-1" for="subtitle" value="عنوان فرعی" />
                    <Label  class="text-xs text-gray-800" value="(شعار یا جمله ای کوتاه که کسب و کار شما را توصیف می کند)" />
                       <Input
                             id="subtitle"
                             type="text"
                             placeholder="عنوان فرعی"
                             class="block w-full border border-green-900"
                             v-model="items.subTitle"
                             required
                             autofocus
                             autocomplete="subtitle"
                       />
                 </div>
                 <!--added rahim-->
                 <div class="space-y-2">
                  <Label class="text-gray-700 mt-1"   for="Address" value="آدرس"/>
                        <textarea 
                             class="rounded-xl p-2 w-full mt-3 border border-green-900" 
                             placeholder="آدرس" 
                             required
                             v-model="items.address">
                        </textarea> 
                  </div>
                 <!-- Description input -->
                 <div class="space-y-2">
                    <Label class="text-gray-700 mt-1" for="description" value="توضیحات" />
                       <textarea 
                             class="rounded-xl p-2 w-full mt-3 border border-green-900" 
                             placeholder="توضیحات" 
                             v-model="items.description">
                        </textarea>   
                    <!--<Input
                             id="description"
                             type="text"
                             placeholder="Description"
                             class="block w-128 h-full"
                             v-model="items.description"
                             required
                             autofocus
                             autocomplete="description"
                       />-->
                 </div>  
               </TabPanel>
               </TabPanels>
            </TabGroup>
            
            <div class="m-2 ">
                  <Label class="text-white"   for="country" value="کشور"/>
                  <select class="w-52 rounded-xl p-2 bg-white " v-model="selectedcountry" @change="onChange($event)">
                     <option v-for="country in this.CountryList"
                       :key="country.id"
                       :value="country.id"
                       class="text-black">{{ country.name }}
                     </option>
                  </select>
          </div>
          <div class="m-2 ">
                  <Label class="text-white"   for="city" value="شهر"/>
                  <select class="w-52 rounded-xl p-2 bg-white" v-model="selectedcity">
                     <option v-for="city in this.CityList"
                       :key="city.id"
                       :value="city.id"
                       class="text-black">{{ city.name }}
                     </option>
                  </select>
          </div>
                 <div class="m-2 ">
                  <Label class="text-white"   for="Tel" value="تلفن"/>
                     <Input 
                        id="Tel"
                        type="text"
                        placeholder="تلفن"
                        class="block w-full border border-green-900"
                        v-model="store.tel"
                        required
                        autofocus
                        autocomplete="Tel"
                        v-on:keypress="isNumber($event)"
                     />
                  </div>
                 <!--<div class="m-2 ">
                  <Label class="text-white"   for="Address" value="آدرس"/>
                        <textarea 
                             class="rounded-xl p-2 w-full mt-3 border border-green-900" 
                             placeholder="آدرس" 
                             v-model="store.address">
                        </textarea> 
                  </div>-->

       <div class="lg:max-w-6xl sm:max-w-xl mx-auto mt-4 mb-4 font-semibold  ">
        <div class="overflow-hidden shadow-md bg-gray-300">
            <div class="bg-gray-300 p-4 cursor-pointer flex flex-wrap  space-x-2 gap-2" v-on:click="toggleAccordion(1)">
              <div class="sm:text-xs lg:text-lg ">ساعت کاری</div>
                <span class="gap-96 transform transition-transform" id="arrow-icon-1">▼</span>
            </div>
            <div class="grid-container grid grid-cols-3 gap-4 auto-cols-auto" id="accordion-content-1">
                <div class="w-13">
                  <Label class="text-gray-700 mr-1"   for="1" value="شنبه:"/>
                </div>
                <div class="m-0">
                     <Input 
                        id="az"
                        type="text"
                        placeholder="از"
                        class="w-20 border-green-900 "
                        v-model="store.workinghours[0].timeOpen"
                        required
                        autofocus
                        autocomplete="shopname"
                     />
                  </div>
                     <div class="w-6 m-0">
                     <Input 
                        id="az"
                        type="text"
                        placeholder="تا"
                        class="w-20  border-green-900"
                        v-model="store.workinghours[0].timeClosed"
                        required
                        autofocus
                        autocomplete="shopname"
                     />
                </div>
                <div class="w-13">
                     <Label class="text-gray-700 mr-1"   for="1" value="یکشنبه:"/>
                </div>
                <div class="w-6">
                     <Input 
                        id="az"
                        type="text"
                        placeholder="از"
                        class="w-20 border-green-900"
                        v-model="store.workinghours[1].timeOpen"
                        required
                        autofocus
                        autocomplete="shopname"
                     />
                  </div>
                  <div class="w-6">
                     <Input 
                        id="az"
                        type="text"
                        placeholder="تا"
                        class=" w-20 border-green-900"
                        v-model="store.workinghours[1].timeClosed"
                        required
                        autofocus
                        autocomplete="shopname"
                     />
                     </div>
                     <div class="w-13">
                     <Label class="text-gray-700 mr-1"   for="1" value="دوشنبه:"/>
                     </div>
                  <div class="w-6">
                     <Input 
                        id="az"
                        type="text"
                        placeholder="از"
                        class="w-20 border-green-900 "
                        v-model="store.workinghours[2].timeOpen"
                        required
                        autofocus
                        autocomplete="shopname"
                     />
                  </div>
                  <div class="w-6">
                     <Input 
                        id="az"
                        type="text"
                        placeholder="تا"
                        class="w-20 border-green-900"
                        v-model="store.workinghours[2].timeClosed"
                        required
                        autofocus
                        autocomplete="shopname"
                     />
                     </div>
                     <div class="w-13">
                     <Label class="text-gray-700 mr-1"   for="1" value="سه شنبه:"/>
                     </div>
                  <div class="w-6">
                     <Input 
                        id="az"
                        type="text"
                        placeholder="از"
                        class="w-20 border-green-900 "
                        v-model="store.workinghours[3].timeOpen"
                        required
                        autofocus
                        autocomplete="shopname"
                     />
                  </div>
                     <div class="w-6">
                     <Input 
                        id="az"
                        type="text"
                        placeholder="تا"
                        class=" w-20 border-green-900"
                        v-model="store.workinghours[3].timeClosed"
                        required
                        autofocus
                        autocomplete="shopname"
                     />
                     </div>
                     <div class="w-13">
                     <Label class="text-gray-700 mr-1"   for="1" value="چهارشنبه:"/>
                     </div>
                  <div class="w-6">
                     <Input 
                        id="az"
                        type="text"
                        placeholder="از"
                        class="w-20 border-green-900"
                        v-model="store.workinghours[4].timeOpen"
                        required
                        autofocus
                        autocomplete="shopname"
                     />
                  </div>
                     <div class="w-6">
                     <Input 
                        id="az"
                        type="text"
                        placeholder="تا"
                        class="w-20 border-green-900"
                        v-model="store.workinghours[4].timeClosed"
                        required
                        autofocus
                        autocomplete="shopname"
                     />
                     </div>
                     <div class="w-13">
                     <Label class="text-gray-700 mr-1"   for="1" value="پنج شنبه:"/>
                     </div>
                  <div class="w-6">
                     <Input 
                        id="az"
                        type="text"
                        placeholder="از"
                        class=" border-green-900 w-20"
                        v-model="store.workinghours[5].timeOpen"
                        required
                        autofocus
                        autocomplete="shopname"
                     />
                  </div>
                     <div class="w-6">
                     <Input 
                        id="az"
                        type="text"
                        placeholder="تا"
                        class=" border-green-900 w-20"
                        v-model="store.workinghours[5].timeClosed"
                        required
                        autofocus
                        autocomplete="shopname"
                     />
                     </div>
                     <div class="w-13">
                     <Label class="text-gray-700 mr-1"   for="1" value="جمعه:"/>
                     </div>
                  <div class="w-6">
                     <Input 
                        id="az"
                        type="text"
                        placeholder="از"
                        class=" border-green-900 w-20 "
                        v-model="store.workinghours[6].timeOpen"
                        required
                        autofocus
                        autocomplete="shopname"
                     />
                  </div>
                     <div class="w-6">
                     <Input 
                        id="az"
                        type="text"
                        placeholder="تا"
                        class="border-green-900 w-20 mb-1"
                        v-model="store.workinghours[6].timeClosed"
                        required
                        autofocus
                        autocomplete="shopname"
                     />
                 </div>
            </div>
        </div>
</div>
         <div class="m-2 flex">
                  <Label class="text-white mt-3"    for="status" value="وضعیت"/>
                  <select class="w-52 rounded-xl p-2 bg-white "  v-model="selectedstatus" >
                     <option v-for="status in this.StatusList"
                       :key="status.id"
                       :value="status.id"
                       class="text-black">{{ status.name }}
                     </option>
                  </select>
                  <div class="flex">
                   <label for="default" class="block text-sm mt-3 mr-2 text-white">تغییر دستی </label>
                   <input id="default" type="checkbox"  v-model="store.isStatusChangeManual" >
                  </div>
          </div>
            <div class="flex items-center">  
            <div id="app" v-if="this.store.id!=0">
            <div class="w-32 h-32">
            <img v-bind:src="this.baseurl+'\\'+this.imgurl"/>
            </div>
            <div class="flex gap-2 px-2">
            <Button  @click="$refs.file.click()">انتخاب فایل
            </Button>
            <input type="file" ref="file" @change="onFileChanged" style="display:none">
            <Button class="flex-1 justify-center px-2" @click="onUpload">آپلود</Button>
            <Button id="delete" class="bg-blue-500 rounded-3xl w-32 text-sm" @click="confirmRemoveImage">حذف تصویر</Button>

            </div>
            <p class="text-sm text-gray-500 mt-2">
            حداکثر حجم مجاز فایل: 50 کیلوبایت
            </p>
            </div>
         </div>
            <!-- Register button -->
           <!-- <router-link
                    :to="{ name: 'ShopList' }"
                    class="text-blue-500 hover:underline"
                >ثبت نام</router-link>-->
            <div class="mt-5 px-2">
                <Button
                    type="submit"
                    class="justify-center w-full gap-2" 
                    :disabled="processing"
                >
                    <span>ثبت</span>
                </Button>
                
            </div>
        </div>
    </form>
   </div>

</template>
  <script>
     import {getStore,EditStore,UploadImage,GetLanguages,getCountries,getCitis/*,getAllCity*/,getStatus,DeleteImage} from "@/API/API";
     import Label from '@/components/Label.vue'
     import Input from '@/components/Input.vue'
     //import Checkbox from '@/components/Checkbox.vue'
     //import PageWrapper from '@/components/PageWrapper.vue'
     import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/vue'
     import Button from '@/components/Button.vue'
     import httpClient from "@/API/HttpClient";
     import Swal from 'sweetalert2';
     //added rahim
     //import Vue from 'vue'
     //import VueTelInput from 'vue-tel-input'

      //Vue.use(VueTelInput)
     //
     export default {
        name: 'Shop',
        components: {
         
         Input,
         Label,
         Button,
         TabGroup, TabList, Tab, TabPanels, TabPanel,

        // PageWrapper
        },
        data() {
           return {
              processing:false,
              updateSuccessful: false,
              lanid:1,
              imgurl:'',
              baseurl:process.env.VUE_APP_BASE_URL,
              store: {slug:'',Logo:null,isActive:false,isStatusChangeManual:false,tel:0,countryId:0,statusId:0,statusName:'',cityId:0,workinghours:[{timeOpen:'',timeClosed:''}],storelocalization:[{shopName:'',subTitle:'',address:'',description:'',languageId:1,id:0}]},
              localizations:[], //[{id:1,localname:"فارسی"}]
              CountryList:[],
              CityList:[],
              StatusList:[],
              selectedcity:0,
              selectedcountry:0,
              selectedstatus:0
              
        }
        },
         async created() {
            console.log(1001);
            console.log(this.baseurl+'\\'+this.imgurl);
            
         this.$Progress.start()
         httpClient.defaults.headers.common['Authorization'] = this.$store.getters.token;
         //console.log(httpClient.defaults.headers.common['Authorization']);
         //httpClient.defaults.headers.common['Authorization'] = 'Bearer ' +this.$store.getters.token;
         let templanguages=(await GetLanguages()).data
         //let templanguages=(await GetLanguages()).data.result
         this.localizations=JSON.parse(JSON.stringify(templanguages)) 
         //added rahim
         let tempCountris=(await getCountries()).data
         console.log(tempCountris);
         this.CountryList=JSON.parse(JSON.stringify(tempCountris))
         console.log(1313);
         console.log(this.CountryList);
         console.log(9999);
         console.log(this.selectedcountry);
         let tempStatus=(await getStatus()).data
         console.log(tempStatus);
         this.StatusList=JSON.parse(JSON.stringify(tempStatus))
         //let tempCity=(await getAllCity()).data
         //this.CityList=JSON.parse(JSON.stringify(tempCity))
         
         //console.log(this.selectedcountry);
         //console.log(this.CityList);
         console.log(this.StatusList);
         
         //
         await getStore()
         .then(async response=> {
            //let tmpstore = response.data.result;
            let tmpstore = response.data;
            this.$store.commit('SET_SLUG',tmpstore.slug);
            
            if(tmpstore.storelocalization.length==0)
                tmpstore.storelocalization=this.store.storelocalization;
            console.log(tmpstore.storelocalization)
            this.localizations.forEach(element => {
               console.log(12);
               console.log(element.id);
              
               //console.log(tmpstore.cityId);
               //let res = tmpstore.storelocalization.find(x => x.languageId == element.id);
               //console.log(res);
               if(tmpstore.storelocalization.find(x => x.languageId == element.id)==null)
                  {
                     tmpstore.storelocalization.push({shopName:'',subTitle:'',address:'',description:'',languageId:element.id,id:0})
                  }

            });  
            console.log(tmpstore);
            this.store=JSON.parse(JSON.stringify(tmpstore));   
            console.log(this.store);
            console.log(this.store.isActive);
            this.imgurl=this.store.logoUrl 
            console.log(this.store);
            //console.log(response.data);
            
            //let tempCity=(await getAllCity()).data
            //this.CityList=JSON.parse(JSON.stringify(tempCity))
            this.selectedcountry=tmpstore.countryId
            this.selectedcity=tmpstore.cityId
            this.selectedstatus=tmpstore.statusId
            let tempCitis=(await getCitis(this.selectedcountry)).data
            this.CityList=JSON.parse(JSON.stringify(tempCitis))
            console.log( this.selectedcity);
            this.$Progress.finish()})

         .catch(error => {
            console.log("There was an error!", error);
            this.$swal.fire(error.response.data.Message);
         });
        },
        methods: {
         isLetter(e) {
         let char = String.fromCharCode(e.keyCode); // Get the character
         if(/^[A-Za-z]+$/.test(char)) return true; // Match with regex 
         else e.preventDefault(); // If not match, don't add to input text
         },
         //added rahim
         isNumber(e) {
            let char = String.fromCharCode(e.keyCode);
            if (/^[0-9]+$/.test(char)) return true;
            else e.preventDefault();
        },
        onChange: async function (event) {
         console.log(event.target.value)
         let tempCitis=(await getCitis(event.target.value)).data
         this.CityList=JSON.parse(JSON.stringify(tempCitis))
         //this.$store.commit('SET_DEFCountry',event.target.value );
        },
         //a
         reloadPage(){
           // window.location.reload();
            this.$router.back()
            
         },
         onFileChanged (event) {
         const file = event.target.files[0];
         this.store.Logo=file;
         },
         onUpload() {
            const params = new FormData();
            params.append('Logo',this.store.Logo);
            this.$Progress.start()
            UploadImage('store',String(this.store.id),params)
              .then(response=>  {
               this.imgurl=response.data
               //this.imgurl=response.data.result
               this.updateSuccessful = true
               //console.log(response.data.result);
               this.$Progress.finish()
               })
              //.catch()
              .catch(error => {
            this.errorMessage = error.message;
            console.log("There was an error!", error);
            //this.$swal.fire( error.response.data.result);
            this.$swal.fire(error.response.data.Message);
            this.$Progress.finish();
         });
              
         },
         EditProfile() {
            console.log(698);
            console.log(this.selectedstatus);
            console.log(this.selectedstatus);
            console.log(this.selectedcontry);
            console.log(this.selectedcity);
            this.store.statusId=this.selectedstatus
            this.store.countryId=this.selectedcountry
            this.store.cityId=this.selectedcity
            //console.log('fist');
           if (this.validateStore()) {
            this.$Progress.start()
            console.log(JSON.parse(JSON.stringify(this.store)))
            console.log(this.store)
            //this.store=JSON.parse(JSON.stringify(this.store))
            //const tt=Object.assign({}, this.store )
            EditStore(this.store)
              .then(() => {
               console.log(311);
              
               console.log(this.store);
               this.updateSuccessful = true
               this.$Progress.finish()
               this.showAlert()
               this.reloadPage()
               console.log(312);
               })
               .catch(error => {
            //this.errorMessage = error.response.data.result;
            this.errorMessage =  error.response.data.Message
            console.log("There was an error!", error);
            //console.log("There was an error!", error.response.data.result);
            this.$swal.fire(this.errorMessage)});
            this.$Progress.finish();
           }
            //this.store.StoreLocalizations=this.store.Storelocalization;
            //console.log(this.store);
            

        },
        validateStore() {
        let result = true
        //console.log(this.store);
        /*if (!this.user.customerName) {
            this.error.customerName = 'لطفا نام خود را وارد کنید.'
            result = false
        }*/
        return result
        },
        showAlert() {
        // Use sweetalert2
           //console.log(123456);
           
            this.$swal.fire( 'اطلاعات فروشگاه با موفقیت ثبت شد',
  );
        },
        toggleAccordion: function(index) {
      console.log(1100)
        document.getElementById(`accordion-content-${index}`).classList.toggle("hidden");
        document.getElementById(`arrow-icon-${index}`).classList.toggle("rotate-180");
        },
        removeImage() {
      const params = new FormData();
      params.append('Logo', this.store.Logo);
      this.$Progress.start();

      DeleteImage('store',String(this.store.id),params)
        .then(response => {
          this.imgurlInternal = this.baseurl + '\\' + response.data;
          this.updateSuccessful = true;
          this.$Progress.finish();
        })
        .catch(error => {
          
          this.$swal.fire(error.response.data.Message);
          this.$Progress.finish();
        });
    },
        confirmRemoveImage() {
      Swal.fire({
        title: 'آیا برای حذف مطمئن هستید؟',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'بله، حذف شود!',
        cancelButtonText: 'لغو'
      }).then((result) => {
        if (result.isConfirmed) {
          this.removeImage();
        }
      });
    }
        }
     }
</script>